// src/api/profile.ts
import { API_BASE, buildHeaders, fetchWithAuth } from "../utils/api";

export async function patchTimezone(timezone: string): Promise<boolean> {
  try {
    const res = await fetchWithAuth(`${API_BASE}/api/profile/timezone`, {
      method: "PATCH",
      headers: buildHeaders(true),
      body: JSON.stringify({ timezone }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

// Дату ставит сервер — клиент её не шлёт
export async function patchPwaInstalled(installed: boolean): Promise<boolean> {
  try {
    const res = await fetchWithAuth(`${API_BASE}/api/profile/pwa`, {
      method: "PATCH",
      headers: buildHeaders(true),
      body: JSON.stringify({ pwa_installed: installed }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
